import script from "./ServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesView.vue?vue&type=script&setup=true&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=b4b17ba2&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b17ba2"]])

export default __exports__